import React, { useState } from 'react'
import { Input, toAbsoluteUrl } from 'sr/helpers'
import { FormDetails } from 'sr/helpers/ui-components/FormDetails'
import AuthNavComponent from './AuthNav'
import { FormattedMessage, useIntl } from 'react-intl'
import { ButtonAuth } from 'sr/helpers/ui-components/ButtonAuth'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { forgetPassword } from 'sr/utils/api/forgetPassword'
import { Link } from 'react-router-dom'

export const ForgetPassword = () => {
    const [usernameoremail, setUsernameoremail] = useState()
    const [loader, setLoader] = useState(false)
    const [isEmailSend, setIsEmailSend] = useState(false)
    const intl = useIntl()
    const initialValues = {
      username:usernameoremail
    }
    const usernamevalidate = Yup.object().shape({
      username:Yup.string().required("INPUT.VALIDATION.USERNAME.LOGIN")
  })
    const {errors, handleSubmit} = useFormik({
      initialValues:initialValues,
      enableReinitialize:true,
      validationSchema:usernamevalidate,
      onSubmit: async (values)=> {
        try {
          setLoader(true)
          const res = await forgetPassword(values)
          if(res.success===true) {
           
              setLoader(false)
              setIsEmailSend(true)
          }
          else {
            setLoader(false)
          }
        }
        catch(e:any) {
setLoader(false)
        }
      }
    })
  return (
    <>
    <AuthNavComponent isLoginPage={true}></AuthNavComponent>
    <main>
    <div className='lg:container mx-auto lg:max-w-2xl lg:mt-24 mt-8 px-4 lg:px-0'>
     
      
        <div className='lg:flex block'>
  
        <div className='lg:flex-1 lg:flex flex-col h-fit lg:mx-12 block p-6 bg-white border border-gray-border rounded-xl'>
             <div className="flex justify-center">
                    <Link to="/" className='z-50'>
                      <img width={150} src={toAbsoluteUrl('/media/logos/logo2.png')} alt=''
                        className='bg-white rounded-lg' />
                    </Link>
                  </div>
        {isEmailSend ?
        <div className='w-[15rem] py-20 text-center mx-auto'>
        <FormattedMessage id='AUTH.FORGET.PASSWORD.EMAIL.SEND.TEXT'></FormattedMessage>
      </div> 
      :
      (<>
            <h1 className=' text-xl mt-10'>
            <FormattedMessage
                                id="AUTH.GENERAL.FORGOT_BUTTON"
                                defaultMessage="Forgot Password"
                                />
            </h1>
            <div className='w-full'>
          
              
            <form className='mt-5'>
            <Input
            onChange={(e)=> setUsernameoremail(e.target.value)}
            value={usernameoremail}
            type="text"
           error={errors.username}
              label={intl.formatMessage({
                  id: "AUTH.INPUT.USERNAME.OR.EMAIL",
                  defaultMessage: "Enter Username",
                })}
                                placeholder={intl.formatMessage({
                  id: "AUTH.LOGIN.INPUT.USERNAME.OR.EMAIL.PLACEHOLDER",
                  defaultMessage: "Enter your username",
                })}
                                
                                ></Input>
                            </form>
                           <div className='flex justify-center mt-5'>
                                    <ButtonAuth onClick={handleSubmit}  loader={loader}><FormattedMessage
                                id="AUTH.GENERAL.FORGOT_BUTTON"
                                defaultMessage="Forgot Password"
                                /></ButtonAuth>
                             </div>
                           
        </div>
        </> )}
      </div>
    </div></div>
    
    </main></>
  )
}
